'use client';

import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { ALLOWED_CHARS_REGEXP } from '@/shared/config/password';
import { PasswordInput } from '@/shared/ui/kit/password-input';
import { PasswordStrength, usePasswordStrength } from '@/shared/ui/kit/password-strength';
import { RegistrationFormData } from '@/shared/lib/validation/registration/registration.schema';


export const PasswordField = () => {
    const { control, formState: { errors }, clearErrors } = useFormContext<RegistrationFormData>();
    const password = useWatch({ control, name: 'password' });
    const strength = usePasswordStrength(password ?? '');

    return (
        <Controller
            control={ control }
            name="password"
            render={ ({ field }) => (
                <PasswordInput
                    label="New password:"
                    placeholder='Enter new password'
                    autoComplete="new-password"
                    value={ field.value }
                    onChange={ (e) => {
                        if (!ALLOWED_CHARS_REGEXP.test(e.target.value)) return;
                        field.onChange(e);
                    } }
                    onFocus={ () => clearErrors('password') }
                    state={ errors.password ? 'error' : undefined }
                    error={ errors.password?.message }
                    PasswordStrength={
                        <PasswordStrength
                            hint='Create a strong password:'
                            level={ strength.level }
                            rules={ strength.rules }
                            touched={ !!password }
                        />
                    }
                    required
                />
            ) }
        />
    );
};
